/* eslint-disable max-len */
import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const DragIcon: FC<IconProps> = ({ ...props }) => {
  return (
    <BaseIcon {...props}>
      <path d="M12 10C13.1046 10 14 9.10457 14 8C14 6.89543 13.1046 6 12 6C10.8954 6 10 6.89543 10 8C10 9.10457 10.8954 10 12 10Z" />
      <path d="M12 18C13.1046 18 14 17.1046 14 16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16C10 17.1046 10.8954 18 12 18Z" />
      <path d="M14 24C14 25.1046 13.1046 26 12 26C10.8954 26 10 25.1046 10 24C10 22.8954 10.8954 22 12 22C13.1046 22 14 22.8954 14 24Z" />
      <path d="M20 10C21.1046 10 22 9.10457 22 8C22 6.89543 21.1046 6 20 6C18.8954 6 18 6.89543 18 8C18 9.10457 18.8954 10 20 10Z" />
      <path d="M22 16C22 17.1046 21.1046 18 20 18C18.8954 18 18 17.1046 18 16C18 14.8954 18.8954 14 20 14C21.1046 14 22 14.8954 22 16Z" />
      <path d="M20 26C21.1046 26 22 25.1046 22 24C22 22.8954 21.1046 22 20 22C18.8954 22 18 22.8954 18 24C18 25.1046 18.8954 26 20 26Z" />
    </BaseIcon>
  );
};
